module.exports = __webpack_public_path__ + "static/media/edit.0531b4da.svg";